import background from "../images/background.svg";
import LoginForm from "../components/LoginForm";
import { useSearchParams } from "react-router-dom";
import Alert from "../components/Alert";
import SuccessAlert from "../components/SuccessAlert";

const Login = (props) => {
  return (
    <div className="relative h-screen overflow-hidden bg-indigo-900">
      <img
        alt="background"
        src={background}
        className="absolute h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black opacity-25"></div>
      <div className="container relative z-10 mx-auto flex items-center px-6 py-32 md:px-12 xl:py-40">
        <div className="relative z-10 flex w-full flex-col items-center">
          <h1 className="mt-4 text-center leading-tight text-white sm:text-8xl">
            Welcome
          </h1>
          <LoginForm {...props} />
        </div>
      </div>
    </div>
  );
};

export default Login;
